import {atom} from "recoil";
import {persistAtomEffect} from "../effects/persistAtom";

export const loginTypeState = atom({
  key: 'loginTypeState',
  default: '',
  effects: [
    persistAtomEffect
  ]
});
